import {IStatistics} from './interfaces';
import {IAction} from '../interface';
import {InferActionsTypes} from '../helpers';

export const SET_STATISTICS_DASHBOARD = 'SET_STATISTICS_DASHBOARD';
export const setStatisticsDashboard = (stats: IStatistics): IAction<IStatistics> => ({
  type: SET_STATISTICS_DASHBOARD,
  payload: stats
});

const statisticsActions = {
  setStatisticsDashboard
};

export type StatisticsActionsType = InferActionsTypes<typeof statisticsActions>;
